import { hasPath } from 'ramda';
import store from '@/store.js';

const bypass = ['login'];

const insufficentPriviledge = () => {
  window.$eventHub.$emit('showAlert', {
    message: 'Insufficient privilege',
    type: 'error',
  });
};

export const permissionCheck = (to, from, next) => {
  const role = store.getters['auth/auth'].role;

  if (to.name === 'login' && role) {
    next({ name: 'dashboard' });
  } else if (!role && bypass.includes(to.name)) {
    next();
  } else if (to.meta.auth && !role) {
    next({ name: 'login' });
  } else if (hasPath(['meta', 'permission'], to)) {
    if (to.meta.permission.includes(role)) {
      next();
    } else if (from.name === null) {
      insufficentPriviledge();
      next({ name: 'dashboard' });
    } else {
      insufficentPriviledge();
      next({ name: from.name });
    }
  } else {
    next();
  }
};
